import { z } from 'zod';
import { CardEnum, cardStateOrderedSchema } from '../CardState.ts';
import { createKeyRecordSchema } from '../KeyRecordSchemas.ts';
import { createPartialStrictObjectSchemaWithAtLeastOneProperty } from '../PartialStrictObjectSchema.ts';
import { PlayerColor } from '../PlayerState.ts';
import { validateState } from '../ValidateState.ts';
import { EnumUtils } from '@colonist/utils';
const mechanicDevelopmentCardsPlayerStateSchema = z.object({
    developmentCards: cardStateOrderedSchema.readonly(),
    developmentCardsBoughtThisTurn: z.union([
        z.array(z.enum(CardEnum)),
        z.null()
    ]).exactOptional(),
    developmentCardsUsed: z.array(z.enum(CardEnum)),
    hasUsedDevelopmentCardThisTurn: z.union([
        z.literal(true),
        z.null()
    ]).exactOptional()
}).strict();
const mechanicDevelopmentCardsPlayerStatePartialSchema = createPartialStrictObjectSchemaWithAtLeastOneProperty(mechanicDevelopmentCardsPlayerStateSchema);
const playerColorNumericKeys = EnumUtils.getEnumValues(PlayerColor);
const mechanicDevelopmentCardsPlayersSchema = createKeyRecordSchema(playerColorNumericKeys, mechanicDevelopmentCardsPlayerStateSchema);
export const mechanicDevelopmentCardsStateSchema = z.object({
    bankDevelopmentCards: cardStateOrderedSchema.readonly(),
    players: mechanicDevelopmentCardsPlayersSchema.readonly()
}).strict();
export function validateMechanicDevelopmentCardsState(data) {
    return validateState(mechanicDevelopmentCardsStateSchema, data);
}
const mechanicDevelopmentCardsPlayersPartialSchema = createKeyRecordSchema(playerColorNumericKeys, mechanicDevelopmentCardsPlayerStatePartialSchema, {
    requireAtLeastOneEntry: true
});
const mechanicDevelopmentCardsStatePartialShapeSchema = z.object({
    bankDevelopmentCards: cardStateOrderedSchema,
    players: mechanicDevelopmentCardsPlayersPartialSchema
}).strict();
export const mechanicDevelopmentCardsStatePartialSchema = createPartialStrictObjectSchemaWithAtLeastOneProperty(mechanicDevelopmentCardsStatePartialShapeSchema);
